import qs from 'qs';

import axiosInstance from '../request';
import { pickDevParams } from '../../utils/config';

export const getOrdersUrl = (payload, cancelToken) => axiosInstance.get('/orders/list', {
  params: { ...payload, ...pickDevParams },
  cancelToken,
});

export const getOrdersListPagination = (payload, cancelToken) => axiosInstance.get('/orders/list-pagination', {
  params: { ...payload, ...pickDevParams },
  cancelToken,
});

export const getOrdersConfig = (payload, cancelToken) => axiosInstance.get('/orders/configuration', {
  params: { ...payload, ...pickDevParams },
  cancelToken,
});

export const getOrdersStatusesCounts = (payload, cancelToken) => axiosInstance.get('/orders/statuses', {
  params: { ...payload, ...pickDevParams },
  cancelToken,
});

export const getOrdersExportConfig = () => axiosInstance.get('/orders/export-configuration', { params: pickDevParams });

export const changeOrderStatusUrl = (params = {}, id, status) => axiosInstance.post(`/orders/change-status/${id}`, qs.stringify({ status, ...pickDevParams }), { params });

export const cancelOrderUrl = (id, data, params = {}) => axiosInstance.post(`/orders/cancel/${id}`, qs.stringify({ ...data, ...pickDevParams }), { params });
export const cancelOrderReasonUrl = (id, data, params = {}) => axiosInstance.post(`/orders/add-cancel-reason/${id}`, qs.stringify({ ...data, ...pickDevParams }), { params });
export const cancelBulkOrderUrl = (params = {}, data) => axiosInstance.post('/orders/bulk-status', qs.stringify({ ...data, ...pickDevParams }), { params });
export const resendOrdersUrl = (id, params = {}) => axiosInstance.post(`/orders/resend/${id}`, {}, { params: { ...pickDevParams, ...params } });

export const refillOrderUrl = (params = {}, id) => axiosInstance.post(`/orders/refill/${id}`, qs.stringify(pickDevParams), { params });

export const cancelRequestOrderUrl = (id, params = {}) => axiosInstance.post(`/orders/task-cancel/${id}`, qs.stringify(pickDevParams), { params });

export const disableRefillOrderUrl = (params = {}, id) => axiosInstance.post(`/orders/disable-refill/${id}`, qs.stringify(pickDevParams), { params });

export const setOrderPartialUrl = (id, remains, params = {}) => axiosInstance.post(`/orders/set-partial/${id}`, qs.stringify({ remains, ...pickDevParams }), { params });

export const setOrderRemainsUrl = (id, remains, params = {}) => axiosInstance.post(`/orders/set-remains/${id}`, qs.stringify({ remains, ...pickDevParams }), { params });

export const updateOrderRemainsUrl = (id, remains, params = {}) => axiosInstance.post(`/orders/update-remains/${id}`, qs.stringify({ remains, ...pickDevParams }), { params });

export const setStartCountUrl = (id, start_count, params = {}) => axiosInstance.post(`/orders/set-start-count/${id}`, qs.stringify({ start_count, ...pickDevParams }), { params });

export const getOrderDetails = (id) => axiosInstance.get(`/orders/details/${id}`, { params: pickDevParams });

export const getOrderInfo = (id, type, num) => axiosInstance.get(`orders/get-info/${id}`, {
  params: {
    type,
    num,
    ...pickDevParams,
  },
});

export const getSuperAdminOrderDetailsUrl = (id) => axiosInstance.get(`/orders/super-details/${id}`, { params: pickDevParams });

export const changeOrderLink = (id, link, params = {}) => axiosInstance.post(`/orders/change-link/${id}`, qs.stringify({ link, ...pickDevParams }), { params });

export const getOrdersExportListUrl = (payload) => axiosInstance.get('/orders/export-list', { params: { ...payload, ...pickDevParams } });

export const makeOrdersExportUrl = (payload) => axiosInstance.post('/orders/export-make', qs.stringify({ ...payload, ...pickDevParams }));

export const bulkUpdateOrdersStatus = (params = {}, payload) => axiosInstance.post('/orders/bulk-status', qs.stringify({ ...payload, ...pickDevParams }), { params });

export const bulkRefillOrders = (params = {}, payload) => axiosInstance.post('/orders/bulk-refill', qs.stringify({ ...payload, ...pickDevParams }), { params });

export const bulkCancelRequestOrders = (params = {}, payload) => axiosInstance.post('/orders/bulk-cancel', qs.stringify({ ...payload, ...pickDevParams }), { params });

export const getSearchUsersList = (query) => axiosInstance.get('/orders/autocomplete-users', { params: { ...pickDevParams, query } });

export const updateFromProvider = (id, params) => axiosInstance.post(`/orders/update-from-provider/${id}`, qs.stringify(pickDevParams), { params });

export const bulkUpdateFromProvider = (params = {}, payload) => axiosInstance.post('/orders/bulk-update-from-provider', qs.stringify({ ...payload, ...pickDevParams }), { params });

export const deleteReasonHint = (id) => axiosInstance.post(`/orders/hide-cancel-reason/${id}`, qs.stringify(pickDevParams));

export const ordersUpdateFilterMode = (payload, cancelToken) => axiosInstance.get('/orders/filters/modes', { params: { ...payload, ...pickDevParams }, cancelToken });

export const ordersUpdateFilterServices = (payload, cancelToken) => axiosInstance.get('/orders/filters/services', { params: { ...payload, ...pickDevParams }, cancelToken });

export const ordersUpdateFilterSource = (payload, cancelToken) => axiosInstance.get('/orders/filters/sources', { params: { ...payload, ...pickDevParams }, cancelToken });

export const ordersUpdateFilterProviders = (payload, cancelToken) => axiosInstance.get('/orders/filters/providers', { params: { ...payload, ...pickDevParams }, cancelToken });

export const ordersUpdateFilterFailReason = (payload, cancelToken) => axiosInstance.get('/orders/filters/fail_reasons', { params: { ...payload, ...pickDevParams }, cancelToken });
